var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-bar"},_vm._l((_vm.list),function(item){return _c('div',{key:item.value,staticClass:"tab-item",class:{ active: _vm.value === item.value },on:{"click":function($event){return _vm.clickTab(item)}}},[_c('span',{staticClass:"tab-txt"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }